/**
 * Virtual any type for the property decorator.
 */
export class Any {
}
//# sourceMappingURL=any.js.map